var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoubleHung = function SvgDoubleHung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v9H1V3Z",
    stroke: "#000",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16a1 1 0 1 1 2 0h-2ZM0 16a1 1 0 1 1 2 0H0Zm3 6h18v2H3v-2Zm19-1v-5h2v5h-2ZM2 16v5H0v-5h2Zm19 6a1 1 0 0 0 1-1h2a3 3 0 0 1-3 3v-2ZM3 24a3 3 0 0 1-3-3h2a1 1 0 0 0 1 1v2Z",
    fill: "#000"
  })));
};
export { SvgDoubleHung as Component };
export default __webpack_public_path__ + "8c6802acf61e67524cd2c643368f11fd.svg";